module.exports = __webpack_public_path__ + "static/media/renee-hendrix-food-cabinet.f27d1252.jpg";